"use client";
import React, { useState } from "react";
import InputField from "../components/InputField"; // Import your styled InputField component
import Button from "../components/Button"; // Import your styled Button component
import DropZone from "../components/DropZone"; // Component for file uploads
import TextArea from "../components/TextArea"; // Component for notes (Step 3)
import Layout from "../components/Layout"; // Your general layout component
import secure from "../assets/svgs/secure.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DatePickerField from "../components/DatePickerComponent";

const FourStepForm = () => {
  const [step, setStep] = useState(1); // Initialize step state
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    dob: "",
    files: [],
    notes: "",
    reasons: [],
  });
  console.log(formData);
  const [showPopup, setShowPopup] = useState(false);
  const [success, setSuccess] = useState(false);
  const location = useLocation();
  const { doctorId, doctorName, speciality, appointmentDate, slot } =
    location.state || {};
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const reasonsOptions = [
    "I’m unsure about my diagnosis",
    "My current treatment isn’t working",
    "Exploring treatment options",
    // "I’m unsure about my diagnosis",
  ];

  // Function to handle "Next" button click
  const handleNext = () => {
    if (step < 4) {
      setStep((prevStep) => prevStep + 1); // Use functional state update
    }
  };

  // Function to handle "Previous" button click
  const handlePrevious = () => {
    if (step > 1) {
      setStep((prevStep) => prevStep - 1); // Use functional state update
    }
  };

  // Handle input field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file uploads
  const handleFileUpload = (files) => {
    setFormData((prev) => ({ ...prev, files }));
  };

  const handleReasonChange = (reason) => {
    setFormData((prev) => {
      const { reasons } = prev;
      if (reasons.includes(reason)) {
        return { ...prev, reasons: reasons.filter((r) => r !== reason) };
      } else {
        return { ...prev, reasons: [...reasons, reason] };
      }
    });
  };
  const handleSelectAll = () => {
    if (formData.reasons.length === reasonsOptions.length) {
      setFormData((prev) => ({ ...prev, reasons: [] })); // Deselect all
    } else {
      setFormData((prev) => ({ ...prev, reasons: [...reasonsOptions] })); // Select all
    }
  };

  const handleSubmit = () => {
    setShowPopup(true);
  };

  const confirmSubmission = async () => {
    setShowPopup(false); // Close the popup
    setLoading(true); // Show loading indicator
    setError(null); // Reset error state

    const requestData = {
      doctorId,
      fullName: formData.fullName,
      phoneNumber: formData.phoneNumber,
      email: formData.email,
      documentLink: formData.files[0]?.url || "", // Handle file URL, if applicable
      notes: formData.notes,
      reason: formData.reasons.join(", "), // Combine reasons into a single string
      appointmentDate,
      slot,
    };

    try {
      const response = await fetch(
        "https://backend-58742455872.us-central1.run.app/api/v1/appointment/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Appointment successfully created:", data);
        setSuccess(true); // Show success message
      } else {
        const errorData = await response.json();
        console.error("Failed to create appointment:", errorData.message);
        setError(
          errorData.message ||
            "An error occurred while creating the appointment."
        );
      }
    } catch (err) {
      console.error("Error during API call:", err);
      setError("An unexpected error occurred. Please try again later.");
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };

  const cancelSubmission = () => {
    setShowPopup(false);
  };

  return (
    <Layout>
      <div className="bg-[#F7F7F7]">
        {success ? (
          <div className="flex flex-col items-center justify-center h-screen">
            <div className="text-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-blue-500 mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2l4 -4"
                />
              </svg>
              <h1 className="text-2xl font-bold mt-4">
                Appointment Confirmed!
              </h1>
              <p className="text-gray-500 mt-2">
                Thank you for booking your appointment with us. We’ve
                successfully received your request and look forward to seeing
                you.
              </p>

              {/* Appointment Details Box */}
              <div className="mt-6 bg-white  shadow-lg rounded-lg p-6 w-full">
                <h2 className="text-lg font-bold text-primaryBlue90 mb-4">
                  Appointment Details
                </h2>
                <div className="text-left">
                  <p className="text-sm text-gray-600 mb-2">
                    <span className="font-bold text-gray-800">Doctor:</span>{" "}
                    {doctorName}
                  </p>
                  <p className="text-sm text-gray-600 mb-2">
                    <span className="font-bold text-gray-800">Speciality:</span>{" "}
                    {speciality}
                  </p>
                  <p className="text-sm text-gray-600 mb-2">
                    <span className="font-bold text-gray-800">Date:</span>{" "}
                    {appointmentDate}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-bold text-gray-800">Time:</span>{" "}
                    {slot}
                  </p>
                </div>
              </div>

              <button
                className="bg-orange text-white rounded-[56px] py-3 px-6 mt-6"
                onClick={() => navigate("/locations")}
              >
                Go Back Home
              </button>
            </div>
          </div>
        ) : (
          <div className="p-6 max-w-4xl  mx-auto">
            {/* Doctor Details */}
            <div className="bg-white rounded-lg p-6 mb-6  border-gray-200">
              <div className="flex justify-between items-center">
                <div>
                  <h1 className="text-xl font-bold text-primaryBlue90">
                    {doctorName}
                  </h1>
                  <p className="text-sm text-gray-500">{speciality}</p>
                </div>
                <div>
                  {/* <span className="text-gray-400 text-lg">&gt;</span> */}
                </div>
              </div>
              <div className="mt-2 flex items-center text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-400 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm2 11h4a1 1 0 010 2H8a1 1 0 010-2zm-1-5a1 1 0 000 2h6a1 1 0 000-2H7zm0-3a1 1 0 000 2h6a1 1 0 000-2H7z"
                    clipRule="evenodd"
                  />
                </svg>
                <p>
                  {appointmentDate} at {slot}
                </p>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mb-8 flex justify-between items-center relative">
              {/* Base Gray Bar */}
              <div className="absolute bg-[#E7E7E7] h-1 w-full top-1/2 transform -translate-y-1/2"></div>
              {/* Filled Progress Bar */}
              <div
                className="absolute h-2 bg-[#024E73] top-1/2 transform -translate-y-1/2 transition-all duration-300"
                style={{ width: `${((step - 1) / 3) * 100}%` }} // Dynamically set the width based on step
              ></div>
              {[1, 2, 3, 4].map((s) => (
                <div
                  key={s}
                  className={`flex items-center justify-center w-10 h-10 rounded-full z-10 ${
                    step >= s
                      ? "bg-[#024E73] text-white"
                      : "bg-[#E7E7E7] text-black"
                  }`}
                >
                  {step > s ? "✔" : s}
                </div>
              ))}
            </div>

            {/* Step Content */}
            <div>
              {step === 1 && (
                <div>
                  <h2 className="text-lg font-bold text-[#024E73]">
                    Personal Information
                  </h2>
                  <p className="text-sm text-gray-500 mb-4">
                    Fill in your personal details to get started.
                  </p>
                  <InputField
                    label="Full Name"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="Enter your full name"
                  />
                  <InputField
                    label="Phone Number"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    placeholder="Enter your phone number"
                  />
                  <InputField
                    label="Email Address"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter your email address"
                  />
                  {/* <InputField
                    label="Date of Birth"
                    name="dob"
                    type="date"
                    value={formData.dob}
                    onChange={handleInputChange}
                  /> */}
                  <DatePickerField
                    label="Date of Birth"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                  />
                  <div className="flex items-center">
                    <img src={secure} alt="secure" className="w-6 h-6" />
                    <span className="text-sm text-gray-500">
                      Your information is secure with us
                    </span>
                  </div>
                </div>
              )}

              {step === 2 && (
                <div>
                  <h2 className="text-lg font-bold text-[#024E73]">
                    Upload Documents
                  </h2>
                  <p className="text-sm text-gray-500 mb-4">
                    Upload any relevant documents to help the dentist understand
                    your case better.
                  </p>
                  <DropZone
                    files={formData.files}
                    onUpload={handleFileUpload}
                  />
                </div>
              )}

              {step === 3 && (
                <div>
                  <h2 className="text-lg font-bold text-[#024E73]">
                    Notes for the Dentist
                  </h2>
                  <p className="text-sm text-gray-500 mb-4">
                    Include any notes or specific questions you have for the
                    dentist.
                  </p>
                  <TextArea
                    label="Notes"
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                    placeholder="Describe your symptoms, concerns, or any specific information..."
                  />
                </div>
              )}

              {step === 4 && (
                <div>
                  <h2 className="text-lg font-bold text-[#024E73]">
                    Reason for Second Opinion
                  </h2>
                  <p className="text-sm text-gray-500 mb-4">
                    Select the main reason you’re seeking a second opinion:
                  </p>
                  <div className="space-y-2">
                    <div>
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={
                            formData.reasons.length === reasonsOptions.length
                          }
                          onChange={handleSelectAll}
                          className="mr-2"
                        />
                        Select all
                      </label>
                    </div>
                    {reasonsOptions.map((reason, index) => (
                      <div key={index}>
                        <label className="flex items-center">
                          <input
                            type="checkbox"
                            checked={formData.reasons.includes(reason)}
                            onChange={() => handleReasonChange(reason)}
                            className="mr-2"
                          />
                          {reason}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Navigation Buttons */}
            {/* Navigation Buttons */}
            <div className="flex justify-between mt-6 w-full">
              {step === 1 && (
                <div className="w-full pr-2">
                  <button
                    className=" border bg-gray-300 text-black rounded-[56px] py-3 px-6 w-full font-semibold text-base"
                    onClick={() => navigate("/locations")}
                  >
                    back
                  </button>
                </div>
              )}
              {step > 1 && (
                <div className="w-1/2 pr-2" onClick={handlePrevious}>
                  <button className="bg-orange text-white rounded-[56px] py-3 px-6 w-full font-semibold text-base">
                    Previous
                  </button>
                </div>
              )}
              {step < 4 && (
                <div
                  className={`${step > 1 ? "w-1/2 pl-2" : "w-full"}`}
                  onClick={handleNext}
                >
                  <button className="bg-orange text-white rounded-[56px] py-3 px-6 w-full font-semibold text-base">
                    Next
                  </button>
                </div>
              )}
              {step === 4 && (
                <div
                  className={`${step > 1 ? "w-1/2 pl-2" : "w-full"}`}
                  onClick={handleSubmit}
                >
                  <button className="bg-orange text-white rounded-[56px] py-3 px-6 w-full font-semibold text-base">
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {showPopup && (
          <div className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
              <h2 className="text-lg font-bold mb-4">
                Terms & Conditions Acceptance!
              </h2>
              <ul className="list-disc pl-6 text-sm text-gray-500 mb-4">
                <li>
                  You have read and understood the Terms and Conditions and our
                  Privacy Policy.
                </li>
                <li>
                  You accept that your data will be used according to our stated
                  policies.
                </li>
                <li>
                  You agree that the services provided are based on the
                  information you submit and do not guarantee specific results.
                </li>
                <li>
                  You confirm that all information you provide is accurate to
                  the best of your knowledge.
                </li>
              </ul>
              <div className="flex justify-between">
                <button
                  className="bg-orange text-white rounded-lg py-2 px-6"
                  onClick={confirmSubmission}
                >
                  Yes, Submit
                </button>
                <button
                  className="bg-gray-300 text-black rounded-lg py-2 px-6"
                  onClick={cancelSubmission}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default FourStepForm;
